import ajax from 'api/ajax'
// 台账信息
class parameterMessage {
    // 获取台账信息tab
    getParameterlist = ( per_page, page ,key) => ajax('chem-storage/search',{'per-page':per_page, page ,key}, 'get')
    // 增加台账获取人员列表
    getParameterUser = ( PER_PAGE, PAGE ,LIST) => ajax('chem-user/search',{'per-page':PER_PAGE, PAGE ,LIST}, 'get')
    //  台账商品详情
    getParameterDetail = (storageno) => ajax('chem-storage/view',{storageno}, 'get')
    //  台账信息详情
    getParameterMsg = ( PER_PAGE, page ,storageno,list) => ajax('dict-ledger/search',{'per-page':PER_PAGE, page ,storageno,list}, 'get')
//    删除台账
    deleteParameter = (LEDGER_NO) => ajax('dict-ledger/delete',{LEDGER_NO}, 'post')
//    新增台账
    addParameter = (REMARK,STORAGE_NO,USER_ID_1,USER_ID_2,USER_NAME_1,USER_NAME_2,USE_VOLUME,date,time) => ajax('dict-ledger/create',{REMARK,STORAGE_NO,USER_ID_1,USER_ID_2,USER_NAME_1,USER_NAME_2,USE_VOLUME,date,time}, 'post')
}

export default parameterMessage
